import { render, staticRenderFns } from "./addMaterialRequisitionForm.vue?vue&type=template&id=1bfcb8d8&scoped=true&"
import script from "./addMaterialRequisitionForm.vue?vue&type=script&lang=js&"
export * from "./addMaterialRequisitionForm.vue?vue&type=script&lang=js&"
import style0 from "./addMaterialRequisitionForm.vue?vue&type=style&index=0&id=1bfcb8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfcb8d8",
  null
  
)

export default component.exports